import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import FieldItem from './FieldItem';

const cellHeader = {
    backgroundColor: (theme) => theme.palette.tabHeader.main,
    fontWeight: 'bold',
    padding: '12px',
};

const FieldSection = ({ label, profile, model, onChange }) => {
    return (
        <Box
            sx={{
                mb: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    {label && (
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2} sx={cellHeader}>
                                    {label}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                    )}
                    <TableBody>
                        {model.map((item, index) => (
                            <FieldItem
                                key={index}
                                profile={profile}
                                item={item}
                                onChange={onChange}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default FieldSection;
